import AdminLayout from "../../components/admin/layout/AdminLayout";
import ManagerSidebar from "../../components/managerLiveDashboard/sidebar/ManagerSidebar";
import ManagerSettings from "../../components/managerLiveDashboard/setting/ManagerSettings";

function SettingsPage() {
  return (
    <AdminLayout sidebarComponent={ManagerSidebar}>
      <ManagerSettings />
    </AdminLayout>
  );
}

export default SettingsPage;
